// src/pages/WritePost/index.jsx
import React, { useState, useEffect } from 'react'; 
import { Layout, Form, Input, Button, message, Select, Tag } from 'antd';
import AppHeader from '../../components/Header';
import AppFooter from '../../components/Footer';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import './index.css';

const { Content } = Layout;
const { TextArea } = Input;
const { Option } = Select;

const WritePost = ({ onAddPost, posts, loggedInUser, onLogout }) => {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [availableTags, setAvailableTags] = useState([]);
    useEffect(() => {
        if (posts && posts.length > 0) {
            const allTags = new Set();
            posts.forEach(post => post.tags.forEach(tag => allTags.add(tag)));
            setAvailableTags(Array.from(allTags));
        }
    }, [posts]);    
    const onFinish = (values) => {
        const newTags = Array.isArray(values.tags) ? values.tags : (values.tags ? [values.tags] : []);
        const newPost = {
            id: String(Date.now()), // 简单生成一个唯一 ID
            title: values.title,
            author: loggedInUser ? loggedInUser.username : '匿名作者', // 使用登录用户的用户名作为作者
            date: moment().format('YYYY-MM-DD HH:mm:ss'),
            tags: newTags,
            summary: values.summary,
            content: values.content,
        };
        if (onAddPost) {
            onAddPost(newPost);
            message.success('文章发布成功！');
            form.resetFields();
            navigate('/');
        } else {
            message.error('文章发布失败，缺少添加方法。');
        }
    };
    return (
        <Layout className="blog-layout">
            <AppHeader loggedInUser={loggedInUser} onLogout={onLogout} />
            <Content className="blog-content write-post-content">
                <div className="write-post-container">
                    <h2 className="page-title">撰写新文章</h2>
                    <Form
                        form={form}
                        name="write_post"
                        layout="vertical"
                        onFinish={onFinish}
                        className="write-post-form"
                    >
                        <Form.Item
                            label="文章标题"
                            name="title"
                            rules={[{ required: true, message: '请输入文章标题！' }]}
                        >
                            <Input placeholder="请输入文章标题" />
                        </Form.Item>

                        <Form.Item
                            label="文章摘要"
                            name="summary"
                            rules={[{ required: true, message: '请输入文章摘要！' }]}
                        >
                            <TextArea rows={4} placeholder="请输入文章摘要，不超过200字" maxLength={200} />
                        </Form.Item>

                        <Form.Item
                            label="标签"
                            name="tags"
                            rules={[{ required: true, message: '请选择或输入至少一个标签！' }]}
                        >
                            <Select
                                mode="tags" 
                                style={{ width: '100%' }}
                                placeholder="选择或输入标签 (按回车键创建新标签)"
                                allowClear
                            >
                                {availableTags.map(tag => (
                                    <Option key={tag} value={tag}>
                                        <Tag color="blue">{tag}</Tag>
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Form.Item
                            label="文章内容 (支持Markdown语法)"
                            name="content"
                            rules={[{ required: true, message: '请输入文章内容！' }]}
                        >
                            <TextArea rows={15} placeholder="请使用 Markdown 格式输入文章内容" />
                        </Form.Item>

                        <Form.Item>
                            <Button type="primary" htmlType="submit" className="submit-button">
                                发布文章
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </Content>
            <AppFooter />
        </Layout>
    );
};

export default WritePost;
